import { SubscriptionTier, UserType } from "enums/account";
import { ReactElement } from "react";

export enum SubscriptionStatus {
  ENABLED = 1,
  DISABLED = 2,
}
export type Subscription = {
  id?: number;
  account_type: UserType;
  tier: SubscriptionTier;
  member_count: number;
  client_count: number;
  project_count: number;
  milestone_count: number;
  task_count: number;
  invoice_count: number;
  report_count: number;
  rank: number;
  price: number;
  discount_amount: number;
  task_history_days: number;
  time_tracking_report_history_days: number;
  task_details_report_history_days: number;
  screenshots_lifetime: number;
  status: SubscriptionStatus;
};
export type SubscriptionProps = {
  onClose: () => void;
  subscription: Subscription;
};
export type AddSubscriptionProps = {
  onClose: () => void;
};

export interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: any;
}
export type StatConfig = {
  key: keyof Subscription;
  icon: ReactElement;
};
